module.exports = __webpack_public_path__ + "b2ba5959ef333061d12e7ed341a55d5d.pdf";